module.exports = __webpack_public_path__ + "static/img/pic_phone.943a630f.png";